import {TrackableMetricDTO} from "./trackable-metric.model";

export type trackableType = 'EVENT' | 'TEMPLATE' | 'PLACE';
export class TrackableEntity {
  metrics?: TrackableMetricDTO;
  id?: number;
  type?: trackableType;
}
